import { keysToSnake } from '#/api/adapters/wireCase';

/**
 * 物料列寫入：只保留契約欄位；剝除 nested `material` 與 legacy `materialId`。
 *
 * @param {object} row
 */
function serializeMaterialRow(row) {
  if (!row || typeof row !== 'object') {
    return row;
  }
  const {
    material: _material,
    materialId: _materialId,
    ...rest
  } = row;
  return rest;
}

/**
 * 產品 create／update body（camel → snake）。
 * - **不送** `status`
 * - `materials`／`extraItems` 有傳則原樣帶入（呼叫端負責 replace-all 語意）
 * - materials 列只送 `mtrId` 等寫入欄；不送 `materialId` alias／讀取展開
 *
 * @param {object} payload
 */
export function serializeProductWrite(payload) {
  const { status: _ignored, materials, extraItems, ...rest } = payload ?? {};
  const body = { ...rest };

  if (materials !== undefined) {
    body.materials = (materials ?? []).map(serializeMaterialRow);
  }
  if (extraItems !== undefined) {
    body.extraItems = extraItems;
  }

  return keysToSnake(body);
}
